(function( root, $, undefined ) {

    $(function () {
        // DOM ready, take it away
        const swiperHero = new Swiper('.hero-images .swiper', {
            loop: true,
            effect: "fade",
            navigation: {
                nextEl: ".hero-content-box .swiper-button-next",
                prevEl: ".hero-content-box .swiper-button-prev",
            },
        });

        const swiperBox = new Swiper('.hero-content-box .swiper', {
            loop: true,
            navigation: {
                nextEl: ".hero-content-box .swiper-button-next",
                prevEl: ".hero-content-box .swiper-button-prev",
            },
            autoplay: {
                delay: 5000,
            },
            on: {
                slideChange: function(swiper) {
                    console.log(swiper.activeIndex);
                    swiperHero.slideTo(swiper.activeIndex);
                }
            }
        });

        $('.wydawnictwo-list-item h2 a').matchHeight({byRow: true});
        $('.wydawnictwo-list-item .author').matchHeight({byRow: true});

        $('.wydarzenia-list-item h2').matchHeight({byRow: true});
        $('.wydarzenia-list-item p').matchHeight({byRow: true});

        if (window.location.href.indexOf("/galeria/") > -1) {
            $('.page-menu a[href="/galeria/"]').parent().addClass('active');
        }

        $('.page-menu .menu-item-has-children').append('<span class="sub-menu-toggle"></span>');

        $('.page-menu .current-menu-parent, .page-menu .current-menu-item, .page-menu .current-page-ancestor').addClass('sub-menu-expanded');

        $('.sub-menu-toggle').click(function(){
            $(this).parent().toggleClass('sub-menu-expanded');
            $(this).parent().find('.sub-menu').slideToggle();
        });

        $('.main-nav a[href="#"]').click(function(e){
            e.preventDefault();
        });

        $('.lightbox-images img').each(function(){
            var src = $(this).attr('src');
            $(this).wrap('<a href="'+src+'" data-lightbox="gallery"></a>');
        });
        lightbox.init();

    });

} ( this, jQuery ));
